<script>
export default {
  name: 'LoadingDots',

  props: {
    size: {
      default: 'large',
      type: String,
    },

    color: {
      default: 'light',
      type: String,
    },
  },
};
</script>

<template>
  <div class="dots" :class="size">
    <div class="dot bounce" :class="[size, color]" />
    <div class="dot bounce bounce-1" :class="[size, color]" />
    <div class="dot bounce bounce-2" :class="[size, color]" />
  </div>
</template>

<style lang="scss" scoped>
$height-small: 8px;
$height-large: 10px;
$height-huge: 18px;

$dot-color-light: #e0f6ff;

.dots {
  justify-content: center;
  display: flex;
  box-sizing: content-box;

  &.small {
    height: $height-small * 2;
  }

  &.large {
    height: $height-large * 2;
  }

  &.huge {
    height: $height-huge * 2;
  }
}

.dot {
  opacity: 0.6;
  animation-duration: 0.8s;
  border-radius: 100% 100% 100% 100%;
  align-self: flex-end;
  animation-iteration-count: infinite;
  transform-origin: bottom;

  &.light {
    background: $dot-color-light;
  }

  &.dark {
    background: lighten($interaction-color-primary, 30%);
  }

  &.huge {
    margin: 0 10px;
    height: $height-huge;
    width: $height-huge;
  }

  &.large {
    margin: 0 6px;
    height: $height-large;
    width: $height-large;
  }

  &.small {
    margin: 0 4px;
    height: $height-small;
    width: $height-small;
  }
}

.bounce {
  animation-timing-function: ease-in-out;
  animation-name: bounce;
}

.bounce-1 {
  -webkit-animation-delay: -0.2s;
  animation-delay: -0.2s;
}

.bounce-2 {
  -webkit-animation-delay: -0.4s;
  animation-delay: -0.4s;
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-100%);
    opacity: 1;
  }
  100% {
    transform: translateY(0px);
  }
}
</style>
